import { Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'

const useAddDefaultStock = (
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((scheduleRef: FirebaseDocRefType, type: StockUnionType) => void) => {
  return useCallback(
    (scheduleRef: FirebaseDocRefType, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState
        const index = prevState.findIndex((prevState) => prevState.schedule_ref?.id === scheduleRef.id)
        nextState[index].default_stocks.push({ pickupable_time: '', stock: 0 })
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useAddDefaultStock
